module.exports = __webpack_public_path__ + "img/mobile-logo.b542db7e.png";